import React, { useEffect, useRef, useState } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import MasterViewController from "../../redux/actions/masterApiActions";
import ModuleMasterFormModal from "./AddModuleMaster";
import ExportButton from "../../components/ag grid/ExportButton";
import ReusableGrid from "../../components/ag grid/ReusableGrid";

import "../../styles/styles.css";
import "../../styles/layout.css";

const ModuleMasterListPage = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [editModule, setEditModule] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  const { getPermissionMasters, deletePermissionMaster } = MasterViewController();
  const { permission_masters } = useSelector((state) => state.master);

  useEffect(() => {
    dispatch(getPermissionMasters());
  }, [dispatch]);

  const handleDelete = (id) => dispatch(deletePermissionMaster(id));

  const handleEdit = (module) => {
    setEditModule(module);
    setShowModal(true);
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80,
    },
    {
      headerName: "Module Name",
      field: "module_name",
      flex: 1,
    },
    {
      headerName: "Module Key",
      field: "module_key",
      flex: 1,
    },
    {
      headerName: "Available Actions",
      field: "available_actions",
      flex: 2,
      valueFormatter: (params) => params.value?.join(", "),
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => handleEdit(params.data)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex  mb-3" style={{ justifyContent: "space-between" }}>
        <div>
          {selectedRows.length > 0 && (
            <ExportButton
              gridRef={gridRef}
              fileName="permission_modules.xlsx"
              exportColumns={["module_name", "module_key", "available_actions"]}
            />
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <PageSizeSelector
          pageSize={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
        />
        <div className="mt-2">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircleOutline />}
            onClick={() => {
              setEditModule(null);
              setShowModal(true);
            }}
          >
            Add Module
          </Button>
        </div>
        </div>
      </div>
      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Module Master</h3>
          </Col>
        </Row>
      </div>

      <div className="list-grid-container" style={{ height: "70vh" }}>
        <ReusableGrid
          gridRef={gridRef}
          rowData={permission_masters || []}
          columnDefs={columnDefs}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>
      {showModal && (
        <ModuleMasterFormModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          initialData={editModule}
        />
      )}
    </div>
  );
};

export default ModuleMasterListPage;
